import React from 'react';
import PropTypes from 'prop-types';
import { classes } from './styles/modify-legal';
import { Col, Row, FormGroup, Label, Input } from 'reactstrap';
import { translate } from 'react-i18next';

class ModifyAddress extends React.Component {

  render() {
    const {
      t,
      line1,
      line2,
      city,
      zip,
      state,
      country,
      onLine1,
      onLine2,
      onCity,
      onZip,
      onState,
      onCountry,
      disabled
    } = this.props;
    const getFieldProps = (value, fn) => ({
      value,
      onChange: (event) => fn(event.target.value)
    });
    return (
      <React.Fragment>
        <div className={classes.titleContainer}>
          <h6 className={classes.title}>{t('modifyAddress.title')}</h6>
        </div>
        <Row>
          <Col md={4}>
            <FormGroup>
              <Label for="modify_line1">{t('modifyAddress.line1Label')}<span className={classes.requiredIndicator}>*</span></Label>
              <Input
                type="text"
                name="modify_line1"
                id="modify_line1"
                placeholder={t('modifyAddress.line1Placeholder')}
                disabled={disabled}
                {...getFieldProps(line1, onLine1)}
              />
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup>
              <Label for="modify_line2">{t('modifyAddress.line2Label')}<span className={classes.requiredIndicator}>*</span></Label>
              <Input
                type="text"
                name="modify_line2"
                id="modify_line2"
                placeholder={t('modifyAddress.line2Placeholder')}
                disabled={disabled}
                {...getFieldProps(line2, onLine2)}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={4}>
            <FormGroup>
              <Label for="modify_city">{t('modifyAddress.cityLabel')}<span className={classes.requiredIndicator}>*</span></Label>
              <Input
                type="text"
                name="modify_city"
                id="modify_city"
                placeholder={t('modifyAddress.cityPlaceholder')}
                disabled={disabled}
                {...getFieldProps(city, onCity)}
              />
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup>
              <Label for="modify_zip">{t('modifyAddress.zipLabel')}<span className={classes.requiredIndicator}>*</span></Label>
              <Input
                type="text"
                name="modify_zip"
                id="modify_zip"
                placeholder={t('modifyAddress.zipPlaceholder')}
                disabled={disabled}
                {...getFieldProps(zip, onZip)}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={4}>
            <FormGroup>
              <Label for="modify_state">{t('modifyAddress.stateLabel')}<span className={classes.requiredIndicator}>*</span></Label>
              <Input
                type="select"
                name="modify_parentUuid"
                id="modify_parentUuid"
                disabled={disabled}
                {...getFieldProps(state, onState)}
              >
                <option value="" disabled>{t('modifyAddress.statePlaceholder')}</option>
                <option value="AL">AL - Alabama</option>
                <option value="AK">AK - Alaska</option>
                <option value="AZ">AZ - Arizona</option>
                <option value="AR">AR - Arkansas</option>
                <option value="CA">CA - California</option>
                <option value="CO">CO - Colorado</option>
                <option value="CT">CT - Connecticut</option>
                <option value="DE">DE - Delaware</option>
                <option value="DC">DC - District of Columbia</option>
                <option value="FL">FL - Florida</option>
                <option value="GA">GA - Georgia</option>
                <option value="HI">HI - Hawaii</option>
                <option value="ID">ID - Idaho</option>
                <option value="IL">IL - Illinois</option>
                <option value="IN">IN - Indiana</option>
                <option value="IA">IA - Iowa</option>
                <option value="KS">KS - Kansas</option>
                <option value="KY">KY - Kentucky</option>
                <option value="LA">LA - Louisiana</option>
                <option value="ME">ME - Maine</option>
                <option value="MD">MD - Maryland</option>
                <option value="MA">MA - Massachusetts</option>
                <option value="MI">MI - Michigan</option>
                <option value="MN">MN - Minnesota</option>
                <option value="MS">MS - Mississippi</option>
                <option value="MO">MO - Missouri</option>
                <option value="MT">MT - Montana</option>
                <option value="NE">NE - Nebraska</option>
                <option value="NV">NV - Nevada</option>
                <option value="NH">NH - New Hampshire</option>
                <option value="NJ">NJ - New Jersey</option>
                <option value="NX">NX - New Mexico</option>
                <option value="NY">NY - New York</option>
                <option value="NC">NC - North Carolina</option>
                <option value="ND">ND - North Dakota</option>
                <option value="NC">NC - Ohio</option>
                <option value="OK">OK - Oklahoma</option>
                <option value="OR">OR - Oregon</option>
                <option value="PA">PA - Pennsylvania</option>
                <option value="PR">PR - Puerto Rico</option>
                <option value="RI">RI - Rhode Island</option>
                <option value="SC">SC - South Carolina</option>
                <option value="SD">SD - South Dakota</option>
                <option value="TN">TN - Tennessee</option>
                <option value="TX">TX - Texas</option>
                <option value="UT">UT - Utah</option>
                <option value="VT">VT - Vermont</option>
                <option value="VA">VA - Virginia</option>
                <option value="WA">WA - Washington</option>
                <option value="WV">WV - West Virginia</option>
                <option value="WI">WI - Wisconsin</option>
                <option value="WY">WY - Wyoming</option>
              </Input>
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup>
              <Label for="modify_country">{t('modifyAddress.countryLabel')}<span className={classes.requiredIndicator}>*</span></Label>
              <Input
                type="select"
                name="modify_country"
                id="modify_country"
                disabled={disabled}
                {...getFieldProps(country, onCountry)}
              >
                <option value="" disabled>{t('modifyAddress.countryPlaceholder')}</option>
                <option value="US">United States</option>
                <option value="CA">Canada</option>
              </Input>
            </FormGroup>
          </Col>
        </Row>
      </React.Fragment>
    )
  }

}

ModifyAddress.propTypes = {
  line1: PropTypes.string.isRequired,
  line2: PropTypes.string.isRequired,
  city: PropTypes.string.isRequired,
  zip: PropTypes.string.isRequired,
  state: PropTypes.string.isRequired,
  country: PropTypes.string.isRequired,
  onLine1: PropTypes.func.isRequired,
  onLine2: PropTypes.func.isRequired,
  onCity: PropTypes.func.isRequired,
  onZip: PropTypes.func.isRequired,
  onState: PropTypes.func.isRequired,
  onCountry: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};

export default translate(['customer'])(ModifyAddress);


// WEBPACK FOOTER //
// ./src/views/customer/modify-address.js